import PopoverMenu from "components/PopoverMenu";
import clsx from "clsx";
import PropertyIcon from "./PropertyIcon";
import { PropertyTypeChoices } from "api-client";
import { useTranslation } from "react-i18next";
import { PropertyValue } from "features/BuildingProductEditor/ProductEditorStore";

function AddPropertyButton(props: {
  addProperty: (type: PropertyTypeChoices, value: PropertyValue) => void;
}) {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const handleAddProperty = (type: PropertyTypeChoices) => {
    let value: PropertyValue = "";
    if (
      type === PropertyTypeChoices.Text ||
      type === PropertyTypeChoices.Number
    )
      value = "";
    if (type === PropertyTypeChoices.Boolean) value = false;
    if (type === PropertyTypeChoices.Multiselect) value = [];
    if (type === PropertyTypeChoices.Select) value = "";
    props.addProperty(type, value);
  };

  const PropertyOptions = [
    { id: PropertyTypeChoices.Text, name: "Text", name_de: "Text" },
    { id: PropertyTypeChoices.Number, name: "Number", name_de: "Nummer" },
    {
      id: PropertyTypeChoices.Multiselect,
      name: "Multi Select",
      name_de: "Mehrfachauswahl",
    },
    { id: PropertyTypeChoices.Select, name: "Select", name_de: "Auswahl" },
    {
      id: PropertyTypeChoices.Boolean,
      name: "Checkbox",
      name_de: "Kontrollkästchen",
    },
  ];

  return (
    <PopoverMenu
      buttonText={t("productEditor.addProperty")}
      className={clsx(
        "text-xs border border-gray-300 rounded-md px-2 py-[1px] text-gray-700",
        "hover:bg-gray-100 hover:border-gray-300 transition font-semibold"
      )}
      panelClassName="!mt-2"
      closeOnClickItem
    >
      {PropertyOptions.map((item) => (
        <div
          key={item.id}
          className={clsx(
            "flex items-center text-gray-700 hover:text-indigo-700 py-2 pl-3 pr-10",
            "hover:bg-indigo-50 cursor-pointer transition"
          )}
          onClick={() => handleAddProperty(item.id)}
        >
          <PropertyIcon name={item.id} size={20} />
          <span className="ml-2 font-medium text-sm">
            {isEng ? item.name : item.name_de}
          </span>
        </div>
      ))}
    </PopoverMenu>
  );
}

export default AddPropertyButton;
